module.exports = __webpack_public_path__ + "img/g_lvse.dd848687.png";